import { render } from "./MovieCard.vue?vue&type=template&id=790af82a"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__